import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, Core2Config} from '../../shared';
import {FinancialItemPostContainerModel} from '../../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class FinancialItemPostService extends BaseApiPublicLoginTemplateService<FinancialItemPostContainerModel,FinancialItemPostContainerModel, FinancialItemPostContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/item-posts/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/item-posts/backoffice-ep';
    this.endpoint_path_website_ep_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/item-posts/website-ep';
    this.httpClient = http;
  }

  uploadImage(formData: FormData, hdrGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + hdrGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + hdrGuid;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + imageGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url + this.endpoint_path + '/replace-file/' + imageGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
}
